module.exports = __webpack_public_path__ + "static/media/chicken.e86829a9.jpeg";